(function () {

  'use strict';



  var leafletPromise = null;

  var lastGeocodeRequestAt = 0;

  var geocodeQueue = Promise.resolve();



  function loadLeaflet() {

    if (window.L && window.L.map) return Promise.resolve(window.L);

    if (leafletPromise) return leafletPromise;



    leafletPromise = new Promise(function (resolve, reject) {

      if (!document.querySelector('link[data-store-locator-leaflet]')) {

        var css = document.createElement('link');

        css.rel = 'stylesheet';

        css.href = 'https://unpkg.com/leaflet\@1.9.4/dist/leaflet.css';

        css.integrity =

          'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';

        css.crossOrigin = '';

        css.setAttribute('data-store-locator-leaflet', 'true');

        document.head.appendChild(css);

      }



      var existing = document.querySelector(

        'script[data-store-locator-leaflet]'

      );



      if (existing) {

        existing.addEventListener(

          'load',

          function () {

            resolve(window.L);

          },

          { once: true }

        );



        existing.addEventListener(

          'error',

          reject,

          { once: true }

        );



        return;

      }



      var script = document.createElement('script');



      script.src =

        'https://unpkg.com/leaflet\@1.9.4/dist/leaflet.js';



      script.integrity =

        'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';



      script.crossOrigin = '';

      script.async = true;

      script.setAttribute(

        'data-store-locator-leaflet',

        'true'

      );



      script.onload = function () {

        resolve(window.L);

      };



      script.onerror = function () {

        reject(new Error('Could not load Leaflet.'));

      };



      document.head.appendChild(script);

    });



    return leafletPromise;

  }



  function haversineKm(lat1, lng1, lat2, lng2) {

    var R = 6371;



    var dLat = ((lat2 - lat1) * Math.PI) / 180;

    var dLng = ((lng2 - lng1) * Math.PI) / 180;



    var a =

      Math.sin(dLat / 2) * Math.sin(dLat / 2) +

      Math.cos((lat1 * Math.PI) / 180) *

        Math.cos((lat2 * Math.PI) / 180) *

        Math.sin(dLng / 2) *

        Math.sin(dLng / 2);



    var c =

      2 *

      Math.atan2(

        Math.sqrt(a),

        Math.sqrt(1 - a)

      );



    return R * c;

  }



  function escapeHtml(value) {

    return String(value == null ? '' : value)

      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/>/g, '&gt;')

      .replace(/"/g, '&quot;')

      .replace(/'/g, '&#039;');

  }



  /*

   * ------------------------------------------------------------

   * GEOCODING CACHE

   * ------------------------------------------------------------

   */



  function geocodeCacheKey(query) {

    return (

      'storeLocatorGeocode:' +

      query.toLowerCase().trim()

    );

  }



  function getCachedGeocode(query) {

    try {

      var raw = localStorage.getItem(

        geocodeCacheKey(query)

      );



      if (!raw) return null;



      var cached = JSON.parse(raw);



      if (

        !cached ||

        !cached.timestamp ||

        !cached.result

      ) {

        return null;

      }



      // Cache for 30 days.

      if (

        Date.now() - cached.timestamp >

        30 * 24 * 60 * 60 * 1000

      ) {

        localStorage.removeItem(

          geocodeCacheKey(query)

        );



        return null;

      }



      return cached.result;

    } catch (e) {

      return null;

    }

  }



  function setCachedGeocode(query, result) {

    try {

      localStorage.setItem(

        geocodeCacheKey(query),

        JSON.stringify({

          timestamp: Date.now(),

          result: result

        })

      );

    } catch (e) {

      // Ignore localStorage errors.

    }

  }



  /*

   * ------------------------------------------------------------

   * GEOCODING

   * ------------------------------------------------------------

   *

   * 6-digit input:

   * postalcode=XXXXXX&country=India

   *

   * City input:

   * q=City, India&countrycodes=in

   *

   * Nominatim supports both free-form and structured searches.

   */



  function geocodeWithOpenStreetMap(query, endpoint) {

    var cached = getCachedGeocode(query);



    if (cached) {

      return Promise.resolve(cached);

    }



    var cleanQuery = query.trim();



    if (!cleanQuery) {

      return Promise.resolve(null);

    }



    var normalizedQuery = cleanQuery.replace(/\s+/g, '');



    var isPincode = /^\d{6}$/.test(normalizedQuery);



    geocodeQueue = geocodeQueue

      .then(function () {

        var waitMs = Math.max(

          0,

          1100 -

            (Date.now() - lastGeocodeRequestAt)

        );



        return new Promise(function (resolve) {

          setTimeout(resolve, waitMs);

        });

      })

      .then(function () {

        lastGeocodeRequestAt = Date.now();



        var baseUrl =

          endpoint ||

          'https://nominatim.openstreetmap.org/search';



        var params = [];



        params.push('format=jsonv2');

        params.push('limit=1');

        params.push('addressdetails=1');



        /*

         * PINCODE SEARCH

         */

        if (isPincode) {

          params.push(

            'postalcode=' +

              encodeURIComponent(normalizedQuery)

          );



          params.push(

            'country=' +

              encodeURIComponent('India')

          );

        }



        /*

         * CITY / LOCATION SEARCH

         */

        else {

          params.push(

            'q=' +

              encodeURIComponent(

                cleanQuery + ', India'

              )

          );



          params.push('countrycodes=in');

        }



        var url =

          baseUrl +

          '?' +

          params.join('&');



        return fetch(url, {

          method: 'GET',

          credentials: 'omit',

          headers: {

            Accept: 'application/json'

          }

        })

          .then(function (res) {

            if (!res.ok) {

              throw new Error(

                'Geocoding request failed with status ' +

                  res.status

              );

            }



            return res.json();

          })

          .then(function (data) {

            if (

              !Array.isArray(data) ||

              !data.length

            ) {

              return null;

            }



            var item = data[0];



            var result = {

              lat: parseFloat(item.lat),

              lng: parseFloat(item.lon),

              label:

                item.display_name ||

                cleanQuery

            };



            if (

              !Number.isFinite(result.lat) ||

              !Number.isFinite(result.lng)

            ) {

              return null;

            }



            setCachedGeocode(

              cleanQuery,

              result

            );



            return result;

          });

      });



    return geocodeQueue;

  }



  /*

   * ------------------------------------------------------------

   * LOCATOR

   * ------------------------------------------------------------

   */



  function initLocator(config) {

    var sectionId = config.sectionId;



    var root = document.getElementById(

      'StoreLocator-' + sectionId

    );



    if (!root || root.dataset.storeLocatorInitialized === 'true') return;
    root.dataset.storeLocatorInitialized = 'true';



    var input = document.getElementById(

      'StoreLocatorInput-' + sectionId

    );



    var radiusSelect = document.getElementById(

      'StoreLocatorRadius-' + sectionId

    );



    var searchBtn = document.getElementById(

      'StoreLocatorSearch-' + sectionId

    );



    var clearBtn = document.getElementById(

      'StoreLocatorClear-' + sectionId

    );



    var useLocationBtn = document.getElementById(

      'StoreLocatorUseLocation-' + sectionId

    );



    var listEl = document.getElementById(

      'StoreLocatorList-' + sectionId

    );



    var mapEl = document.getElementById(

      'StoreLocatorMap-' + sectionId

    );



    var statusEl = document.getElementById(

      'StoreLocatorStatus-' + sectionId

    );



    var stores = [];

    var currentItems = [];



    var map = null;

    var markers = [];

    var activeIndex = null;



    /*

     * ----------------------------------------------------------

     * LOAD STORE DATA

     * ----------------------------------------------------------

     */



    // Load live Shopify Metaobject entries embedded in the section Liquid.
    // Keep legacy JSON compatibility if the previous section is still in use.
    // Follow the pagination URLs generated by Shopify Liquid. Never synthesize
    // page=2, page=3: Shopify can use a different pagination parameter.
    function readStorePage(doc) {
      var element = doc.getElementById(
        config.dataElementId || 'StoreLocatorData-' + sectionId
      );
      if (!element) throw new Error('Store Locator data element missing.');
      var entries = JSON.parse(element.textContent || '[]');
      if (!Array.isArray(entries)) throw new Error('Store page is not an array.');
      return {
        entries: entries,
        nextUrl: element.getAttribute('data-next-url') || ''
      };
    }

    function loadMetaobjectPages() {
      var first = readStorePage(document);
      var combined = [];
      var seenIds = new Set();
      var seenUrls = new Set();
      var previousFingerprint = null;

      function addBatch(entries) {
        // Protect against a provider/cache returning the same page again.
        var fingerprint = entries.map(function (store) {
          return String(store.id || '') + ':' + String(store.name || '');
        }).join('|');
        if (entries.length && fingerprint === previousFingerprint) {
          throw new Error('Shopify returned the same Metaobject page twice. Check pagination/cache.');
        }
        previousFingerprint = fingerprint;
        entries.forEach(function (store) {
          var id = String(store.id || '').trim();
          // Do not dedupe by name: different shops may share the same name.
          if (id && seenIds.has(id)) return;
          if (id) seenIds.add(id);
          combined.push(store);
        });
      }

      addBatch(first.entries);
      function loadNext(nextUrl, pageCount) {
        if (!nextUrl) return Promise.resolve(combined);
        if (pageCount > 40) return Promise.reject(new Error('Too many Store Locator pages.'));

        var url = new URL(nextUrl, window.location.href);
        if (url.origin !== window.location.origin) {
          return Promise.reject(new Error('Store Locator pagination URL has unexpected origin.'));
        }
        // Section Rendering API renders the same Shopify section, with the
        // exact pagination cursor/query string supplied by Liquid.
        url.searchParams.set('section_id', config.sectionRenderId || sectionId);
        var key = url.toString();
        if (seenUrls.has(key)) {
          return Promise.reject(new Error('Repeated Metaobject pagination URL: ' + key));
        }
        seenUrls.add(key);

        return fetch(key, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Store page request failed: HTTP ' + response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var page = readStorePage(doc);
            if (!page.entries.length) {
              throw new Error('Shopify returned an empty Store Locator page.');
            }
            addBatch(page.entries);
            return loadNext(page.nextUrl, pageCount + 1);
          });
      }
      return loadNext(first.nextUrl, 2);
    }

    var storesReady = Promise.resolve()
      .then(function () {
        var dataElement = document.getElementById(
          config.dataElementId || 'StoreLocatorData-' + sectionId
        );
        if (dataElement) return loadMetaobjectPages();
        if (config.dataUrl) {
          return fetch(config.dataUrl).then(function (res) {
            if (!res.ok) throw new Error('Store data HTTP ' + res.status);
            return res.json();
          });
        }
        throw new Error('Dynamic store data was not found. Check section Liquid.');
      })
      .then(function (data) {
        if (!Array.isArray(data)) throw new Error('Store data must be an array.');
        stores = data.map(function (entry) {
          var store = Object.assign({}, entry);
          store.lat = Number(store.lat != null ? store.lat : store.latitude);
          store.lng = Number(store.lng != null ? store.lng : store.longitude);
          store.google_maps_url = store.google_maps_url || store.google_map_url || store.maps_url || '';
          store.name = store.name || '';
          store.address = store.address || '';
          store.phone = store.phone || '';
          store.timings = store.timings || '';
          store.layer = store.layer || '';
          store.notes = store.notes || '';
          return store;
        }).filter(function (store) {
          return store.is_active !== false && store.is_active !== 'false' &&
            store.name && Number.isFinite(store.lat) && Number.isFinite(store.lng) &&
            Math.abs(store.lat) <= 90 && Math.abs(store.lng) <= 180;
        });
        console.info('Store Locator: loaded ' + stores.length + ' active locations.');
        if (!stores.length) throw new Error('No active Store Location entries with valid coordinates found.');
      })
      .catch(function (err) {
        console.error('Store Locator: could not load store data.', err);
        listEl.innerHTML = '<p class="store-locator__hint store-locator__hint--error">' +
          'Store locations could not be fully loaded. Please try refreshing the page.' + '</p>';
        throw err;
      });

    /*

     * ----------------------------------------------------------

     * MAP INITIALIZATION

     * ----------------------------------------------------------

     */



    function ensureMap(center) {

      if (map) return map;



      map = L.map(mapEl, {

        zoomControl: true,

        scrollWheelZoom: true,

        attributionControl: true

      }).setView(

        [center.lat, center.lng],

        8

      );



      /*

       * Google Maps Roadmap tiles through Leaflet

       */

      L.tileLayer(

        'https://mt{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',

        {

          subdomains: [

            '0',

            '1',

            '2',

            '3'

          ],

          maxZoom: 20

        }

      ).addTo(map);



      setTimeout(function () {

        map.invalidateSize();

      }, 50);



      return map;

    }



    /*

     * ----------------------------------------------------------

     * CLEAR MARKERS

     * ----------------------------------------------------------

     */



    function clearMarkers() {

      if (map) {

        map.closePopup();

      }



      markers.forEach(function (marker) {

        if (map) {

          map.removeLayer(marker);

        }

      });



      markers = [];

      activeIndex = null;

    }



    /*

     * ----------------------------------------------------------

     * MARKER ICON

     * ----------------------------------------------------------

     */



    function numberedIcon(number, isActive) {

      var fill = isActive

        ? '#b80300'

        : '#033177';



      var svg =

        '<svg xmlns="http://www.w3.org/2000/svg" ' +

        'width="800px" height="800px" viewBox="0 0 32 32" ' +

        'version="1.1">' +

        '<path fill="' +

        fill +

        '" d="M11.163 11.554c0-2.655 2.166-4.807 4.837-4.807s4.837 2.152 4.837 4.807-2.166 4.806-4.837 4.806-4.837-2.152-4.837-4.806zM7.777 12.154c0 2.011 2.454 6.25 2.454 6.25l5.769 9.614 5.438-9.613c0 0 2.785-4.27 2.785-6.25 0-4.513-3.682-8.171-8.223-8.171s-8.223 3.657-8.223 8.17z"/>' +

        '</svg>';



      return L.icon({

        iconUrl:

          'data:image/svg+xml;charset=UTF-8,' +

          encodeURIComponent(svg),



        iconSize: [30, 40],

        iconAnchor: [15, 40],

        popupAnchor: [0, -34]

      });

    }



    /*

     * ----------------------------------------------------------

     * ACTIVE MARKER

     * ----------------------------------------------------------

     */



    function setActive(index) {

      activeIndex = index;



      Array.prototype.forEach.call(

        listEl.querySelectorAll(

          '.store-locator__item'

        ),

        function (el) {

          el.classList.toggle(

            'is-active',

            Number(el.dataset.index) === index

          );

        }

      );



      markers.forEach(function (

        marker,

        i

      ) {

        marker.setIcon(

          numberedIcon(

            i + 1,

            i === index

          )

        );



        marker.setZIndexOffset(

          i === index ? 1000 : 0

        );

      });

    }



    /*

     * ----------------------------------------------------------

     * RENDER STORE LIST

     * ----------------------------------------------------------

     */



    function validGoogleMapsUrl(url) {
      if (typeof url !== 'string') return '';
      url = url.trim();
      try {
        var parsed = new URL(url);
        if (parsed.protocol !== 'https:') return '';
        var host = parsed.hostname.toLowerCase();
        if (host === 'maps.app.goo.gl' || host === 'goo.gl' && parsed.pathname.indexOf('/maps') === 0) return url;
        if (/^(www\.)?google\.[a-z.]+$/.test(host) && parsed.pathname.indexOf('/maps') === 0) return url;
        if (/^maps\.google\.[a-z.]+$/.test(host)) return url;
      } catch (e) {}
      return '';
    }

    function storeMapsLink(store) {
      return validGoogleMapsUrl(store.google_maps_url) ||
        'https://www.google.com/maps/search/?api=1&query=' +
        encodeURIComponent(store.lat + ',' + store.lng);
    }

    function detailRow(label, value) {
      if (value == null || !String(value).trim()) return '';
      return '<p class="store-locator__detail"><strong>' + escapeHtml(label) +
        ':</strong> ' + escapeHtml(value) + '</p>';
    }

    function renderList(items) {
      currentItems = items;
      if (!items.length) {
        listEl.innerHTML = '<p class="store-locator__hint">No stores found in this radius. Try a wider distance.</p>';
        return;
      }
      listEl.innerHTML = items.map(function (s, i) {
        var storeLink = storeMapsLink(s);
        var phone = String(s.phone || '').trim();
        var phoneHref = phone.replace(/[^+\d]/g, '');
        return '<div class="store-locator__item" data-index="' + i + '">' +
          '<div class="store-locator__item-icon">' + (i + 1) + '</div>' +
          '<div class="store-locator__item-body">' +
          '<h5>' + escapeHtml(s.name) + '</h5>' +
          detailRow('Layer', s.layer) +
          detailRow('Address', s.address) +
          detailRow('Notes', s.notes) +
          (phone ? '<p class="store-locator__detail"><strong>Phone:</strong> <a class="store-locator__phone" href="tel:' + escapeHtml(phoneHref) + '">' + escapeHtml(phone) + '</a></p>' : '') +
          detailRow('Timings', s.timings) +
          '<div class="store-locator__actions">' +
          '<a class="direction-link" href="' + escapeHtml(storeLink) + '" target="_blank" rel="noopener noreferrer">Get Direction</a>' +
          '<button type="button" class="store-locator__share" data-share-index="' + i + '" aria-label="Share ' + escapeHtml(s.name) + ' Google Maps link">Share</button>' +
          '</div></div></div>';
      }).join('');
    }

    listEl.addEventListener('click', function (e) {
      var share = e.target.closest('.store-locator__share');
      if (!share) return;
      e.stopPropagation();
      var store = currentItems[Number(share.dataset.shareIndex)];
      if (!store) return;
      var url = storeMapsLink(store);
      if (navigator.share) {
        navigator.share({title: store.name, url: url}).catch(function (err) {
          if (err.name !== 'AbortError') copyStoreLink(url, share);
        });
      } else {
        copyStoreLink(url, share);
      }
    });

    function copyStoreLink(url, button) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          var original = button.textContent;
          button.textContent = 'Copied!';
          setTimeout(function () { button.textContent = original; }, 1800);
        }).catch(function () { window.prompt('Copy store link:', url); });
      } else {
        window.prompt('Copy store link:', url);
      }
    }

    /*

     * ----------------------------------------------------------

     * LIST CLICK

     * ----------------------------------------------------------

     */



    listEl.addEventListener(

      'click',

      function (e) {

        var itemEl =

          e.target.closest(

            '.store-locator__item'

          );



        if (!itemEl || e.target.closest('a, button')) return;



        var index = Number(

          itemEl.dataset.index

        );



        var store =

          currentItems[index];



        if (

          !store ||

          !map ||

          !markers[index]

        ) {

          return;

        }



        setActive(index);



        map.flyTo(

          [

            store.lat,

            store.lng

          ],

          Math.max(

            map.getZoom(),

            14

          ),

          {

            animate: true,

            duration: 0.6

          }

        );



        markers[index].openPopup();

      }

    );



    /*

     * ----------------------------------------------------------

     * FIT MAP TO CURRENT RESULTS

     * ----------------------------------------------------------

     */



    function fitMapToItems(items) {

      if (

        !map ||

        !items ||

        !items.length

      ) {

        return;

      }



      /*

       * One store:

       * Zoom directly into the store.

       */

      if (items.length === 1) {

        map.setView(

          [

            items[0].lat,

            items[0].lng

          ],

          14,

          {

            animate: true

          }

        );



        return;

      }



      /*

       * Multiple stores:

       * Fit ONLY the currently displayed stores.

       */

      var bounds =

        L.latLngBounds(

          items.map(function (s) {

            return [

              s.lat,

              s.lng

            ];

          })

        );



      map.fitBounds(

        bounds,

        {

          paddingTopLeft: [40, 40],

          paddingBottomRight: [40, 40],



          /*

           * Allows closer zoom than the previous 12.

           */

          maxZoom: 14,



          animate: true

        }

      );

    }



    /*

     * ----------------------------------------------------------

     * RENDER MAP

     * ----------------------------------------------------------

     */



    function renderMap(

      items,

      center,

      fitAllStores

    ) {

      ensureMap(center);



      clearMarkers();



      /*

       * Add only the current result markers.

       */

      items.forEach(function (s, i) {

        var popupHtml =

          '<strong>' +

          escapeHtml(s.name) +

          '</strong><br>' +

          escapeHtml(s.address || '') +
          (s.layer ? '<br><strong>Layer:</strong> ' + escapeHtml(s.layer) : '') +
          (s.notes ? '<br><strong>Notes:</strong> ' + escapeHtml(s.notes) : '') +
          (s.phone ? '<br><strong>Phone:</strong> ' + escapeHtml(s.phone) : '') +
          (s.timings ? '<br><strong>Timings:</strong> ' + escapeHtml(s.timings) : '');



        var marker = L.marker(

          [

            s.lat,

            s.lng

          ],

          {

            title: s.name,

            icon: numberedIcon(

              i + 1,

              false

            )

          }

        ).addTo(map);



        marker.bindPopup(

          popupHtml,

          {

            autoPan: true,

            keepInView: true,

            maxWidth: 280

          }

        );



        marker.on(

          'click',

          function () {

            setActive(i);



            var itemEl =

              listEl.querySelector(

                '.store-locator__item[data-index="' +

                  i +

                  '"]'

              );



            if (itemEl) {

              itemEl.scrollIntoView({

                behavior: 'smooth',

                block: 'nearest'

              });

            }

          }

        );



        markers.push(marker);

      });



      /*

       * --------------------------------------------------------

       * IMPORTANT:

       * Always fit the map to the CURRENT items.

       *

       * Previously this only happened when

       * fitAllStores === true.

       *

       * That meant a city/pincode search could show the

       * correct stores but the map remained at the old zoom.

       * --------------------------------------------------------

       */

      if (items.length) {

        fitMapToItems(items);

      } else {

        map.setView(

          [

            center.lat,

            center.lng

          ],

          10,

          {

            animate: true

          }

        );

      }



      setTimeout(function () {

        map.invalidateSize();



        /*

         * Run fit again after Leaflet has calculated the

         * actual container dimensions.

         */

        if (items.length) {

          fitMapToItems(items);

        }

      }, 100);

    }



    /*

     * ----------------------------------------------------------

     * SHOW RESULTS FROM COORDINATES

     * ----------------------------------------------------------

     */



    function showResultsFromCoords(

      lat,

      lng,

      radiusKm,

      showAllIfEmpty

    ) {

      storesReady

        .then(function () {

          var allWithDistance =

            stores

              .map(function (s) {

                return Object.assign(

                  {},

                  s,

                  {

                    distanceKm:

                      haversineKm(

                        lat,

                        lng,

                        s.lat,

                        s.lng

                      )

                  }

                );

              })

              .sort(function (

                a,

                b

              ) {

                return (

                  a.distanceKm -

                  b.distanceKm

                );

              });



          var nearbyStores =

            allWithDistance.filter(

              function (s) {

                return (

                  s.distanceKm <=

                  radiusKm

                );

              }

            );



          var shouldShowAll =

            showAllIfEmpty &&

            nearbyStores.length === 0;



          var results =

            shouldShowAll

              ? allWithDistance

              : nearbyStores;



          renderList(results);



          /*

           * The map now zooms to ONLY \`results\`.

           */

          renderMap(

            results,

            {

              lat: lat,

              lng: lng

            },

            shouldShowAll

          );



          if (statusEl) {

            statusEl.textContent =

              shouldShowAll

                ? 'No stores found within ' +

                  radiusKm +

                  ' km. Showing all stores instead.'

                : '';

          }

        })

        .catch(function () {

          // storesReady already renders its own error.

        });

    }



    /*

     * ----------------------------------------------------------

     * SHOW ALL STORES

     * ----------------------------------------------------------

     */



    function showAllStoresDefault(

      statusMessage

    ) {

      storesReady

        .then(function () {

          if (!stores.length) return;



          var allStores =

            stores.map(function (

              store

            ) {

              return Object.assign(

                {},

                store,

                {

                  distanceKm: null

                }

              );

            });



          renderList(allStores);



          renderMap(

            allStores,

            {

              lat: allStores[0].lat,

              lng: allStores[0].lng

            },

            true

          );



          if (statusEl) {

            statusEl.textContent =

              statusMessage || '';

          }

        })

        .catch(function () {

          // storesReady already renders its own error.

        });

    }



    /*

     * ----------------------------------------------------------

     * SEARCH

     * ----------------------------------------------------------

     */



    // Search Shopify stores locally by name first. Geographic searches
    // continue to use the existing Nominatim city/pincode logic.
    function normalizeStoreSearch(value) {
      return String(value == null ? '' : value)
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
    }

    function runSearch() {
      var query = input.value.trim();
      var radiusKm = parseFloat(radiusSelect.value) || config.defaultRadiusKm || 20;
      if (!query) {
        if (statusEl) statusEl.textContent = 'Enter a store name, city or pincode.';
        return;
      }

      searchBtn.disabled = true;
      if (statusEl) statusEl.textContent = 'Searching...';

      storesReady.then(function () {
        var needle = normalizeStoreSearch(query);
        var tokens = needle.split(' ').filter(Boolean);
        // Match against the name, and separately against the Layer label.
        // Do not match internal notes or private contact information.
        var matches = stores.filter(function (store) {
          var storeName = normalizeStoreSearch(store.name);
          var layer = normalizeStoreSearch(store.layer);
          return (storeName.includes(needle) || layer.includes(needle) ||
            (tokens.length > 1 && tokens.every(function (token) {
              return storeName.split(' ').some(function (word) {
                return word.startsWith(token);
              });
            })));
        });

        if (matches.length) {
          renderList(matches);
          renderMap(matches, {lat: matches[0].lat, lng: matches[0].lng}, true);
          if (statusEl) statusEl.textContent = matches.length +
            ' matching store' + (matches.length === 1 ? '' : 's') + ' found.';
          return;
        }

        // No local store-name match: retain the original city/pincode search.
        return geocodeWithOpenStreetMap(query, config.geocodingUrl)
          .then(function (result) {
            if (!result) {
              currentItems = [];
              listEl.innerHTML = '<p class="store-locator__hint">Could not find "' +
                escapeHtml(query) + '". Try a store name, city or 6-digit pincode.</p>';
              if (statusEl) statusEl.textContent = '';
              return;
            }
            showResultsFromCoords(result.lat, result.lng, radiusKm, false);
          });
      }).catch(function (err) {
        console.error('Store Locator: search failed.', err);
        if (statusEl) statusEl.textContent = 'Search is temporarily unavailable. Please try again.';
      }).finally(function () {
        searchBtn.disabled = false;
      });
    }

    /*

     * ----------------------------------------------------------

     * USE MY LOCATION

     * ----------------------------------------------------------

     */



    function locateUser(

      isAutomatic

    ) {

      var radiusKm =

        parseFloat(

          radiusSelect.value

        ) ||

        config.defaultRadiusKm ||

        100;



      if (!navigator.geolocation) {

        showAllStoresDefault(

          'Location is not supported on this browser. Showing all stores.'

        );



        return;

      }



      if (statusEl) {

        statusEl.textContent =

          'Locating you...';

      }



      navigator.geolocation.getCurrentPosition(

        function (position) {

          input.value = '';



          showResultsFromCoords(

            position.coords.latitude,

            position.coords.longitude,

            radiusKm,

            isAutomatic

          );

        },



        function () {

          showAllStoresDefault(

            isAutomatic

              ? 'Location access was not available. Showing all stores.'

              : 'Couldn\'t get your location. Showing all stores instead.'

          );

        },



        {

          timeout: 8000,

          maximumAge:

            5 * 60 * 1000

        }

      );

    }



    /*

     * ----------------------------------------------------------

     * EVENTS

     * ----------------------------------------------------------

     */



    searchBtn.addEventListener(

      'click',

      runSearch

    );



    input.addEventListener(

      'keydown',

      function (e) {

        if (e.key === 'Enter') {

          runSearch();

        }

      }

    );



    useLocationBtn.addEventListener(

      'click',

      function () {

        locateUser(false);

      }

    );



    clearBtn.addEventListener(

      'click',

      function () {

        input.value = '';



        var defaultRadius =

          String(

            config.defaultRadiusKm ||

              20

          );



        if (

          radiusSelect.querySelector(

            'option[value="' +

              defaultRadius +

              '"]'

          )

        ) {

          radiusSelect.value =

            defaultRadius;

        }



        showAllStoresDefault();

      }

    );



    /*

     * ----------------------------------------------------------

     * INITIAL LOAD

     * ----------------------------------------------------------

     *

     * Always show all stores.

     */



    showAllStoresDefault();



    /*

     * ----------------------------------------------------------

     * RESPONSIVE MAP

     * ----------------------------------------------------------

     */



    window.addEventListener(

      'resize',

      function () {

        if (map) {

          map.invalidateSize();



          /*

           * Re-fit the currently displayed locations after

           * the container size changes.

           */

          if (currentItems.length) {

            setTimeout(function () {

              fitMapToItems(

                currentItems

              );

            }, 100);

          }

        }

      }

    );

  }



  /*

   * ------------------------------------------------------------

   * BOOT

   * ------------------------------------------------------------

   */



  function boot() {

    var configs =

      window.StoreLocatorSettings ||

      [];



    if (!configs.length) return;



    loadLeaflet()

      .then(function () {

        configs.forEach(

          function (config) {

            initLocator(config);

          }

        );

      })

      .catch(function (err) {

        console.error(

          'Store Locator: Leaflet failed to load.',

          err

        );



        configs.forEach(

          function (config) {

            var statusEl =

              document.getElementById(

                'StoreLocatorStatus-' +

                  config.sectionId

              );



            if (statusEl) {

              statusEl.textContent =

                'Map could not be loaded. Please refresh and try again.';

            }

          }

        );

      });

  }



  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      boot

    );

  } else {

    boot();

  }

})();